// extracted by mini-css-extract-plugin
module.exports = {"right":"Header_right__KXg3n","select":"Header_select__259a6","clinic":"Header_clinic__sBayR"};